// extracted by mini-css-extract-plugin
export default {"skeletonBlock":"SkeletonBlock-skeletonBlock-WFQ","pulse":"SkeletonBlock-pulse-wZf"};